import React from "react";
import logowhite from "../images/logo_white.png";

export default function PageNotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#2d4f5d] text-white">
      <div className="text-center">
        <img className="mx-auto w-240 h-24 mb-4" src={logowhite}></img>

        <h2 className="text-3xl font-semibold mb-4">404 - Page Not Found</h2>
        <p className="text-lg mb-8">
          Oops! The page you are looking for doesn't exist.
        </p>
      </div>
    </div>
  );
}
